<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-menu
          ref="dialog"
          :close-on-content-click="false"
          v-model="birthday"
          :return-value.sync="date"
          lazy
          persistent
          full-width
          min-width="290px"
          class="mt-0 pt-0"
        >
          <v-text-field
            slot="activator"
            class="mt-0 pt-0"
            v-model="date"
            placeholder="Select Date"
            solo
            readonly
            required
            value=date
            clearable
          ></v-text-field>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="setDate(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    props:['startingDateValue'],
    data: () => ({
      date : null,
      birthday: false,
    }),
     methods:{
      setDate(date){
        this.date=date
        this.$refs.dialog.save(date)
        this.birthday=false
        this.$emit('setDate',date)
      }
    },
    watch:{
      date:function(){
        this.$emit('setDate',this.date)
      }
    },
    // updated:function(){
    //   this.setDate(this.date)
    // },
    created:function(){
      if(this.startingDateValue){
        this.date=this.startingDateValue;
      }
      // console.log("this.date: ",this.date)
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/Datepicker1.vue